import { isMobile } from 'mobile-device-detect'

export default function() {
    return {
        isMobile,
        cart: {
            accommodations: [],
            optionals: []
        },
        user: null,
        travelers: [],
        trip: null,
        success: false,
        error: null,
        errors: {
            cpf: null,
            name: null,
            email: null,
            place: null,
            accommodations: null,
            optionals: null
        },
    }
}
